import * as React from 'react';
import { Auth } from 'firebase/auth';
import { EventBus } from '@/shared/utils';
import { StudySessionEventKeys, StudySessionEvents } from '../events';
import { Studysession } from '@/shared/i18n';
import { StudySessionForm } from '../ui/study-session-form';

import { useStudySessions } from '../hooks/use-study-sessions';
import StudySessionsFeedback from '../ui/action-feedback';
import { ProfileLoader } from '../../ui/shared/module-loader';

interface StudySessionScreenProps {
  auth: Auth;
  eventBus: EventBus<StudySessionEvents>;
  dict: Studysession;
}

const StudySessionScreen: React.FC<StudySessionScreenProps> = ({ auth, dict, eventBus }) => {
  const {
    updateStudySession,
    refreshStudySessionsOptions,
    refreshProfileStudySessions,
    studySessionsOptions,
    profileStudySessions,
    resetStore,
  } = useStudySessions(dict, auth);

  React.useEffect(() => {
    eventBus.on(StudySessionEventKeys.studySession.update, updateStudySession);
    eventBus.on(StudySessionEventKeys.studySession.options, refreshStudySessionsOptions);
    eventBus.on(StudySessionEventKeys.studySession.profile, refreshProfileStudySessions);

    return () => {
      resetStore();
      eventBus.off(StudySessionEventKeys.studySession.update, updateStudySession);
      eventBus.off(StudySessionEventKeys.studySession.options, refreshStudySessionsOptions);
      eventBus.off(StudySessionEventKeys.studySession.profile, refreshProfileStudySessions);
    };
  }, [
    eventBus,
    updateStudySession,
    refreshStudySessionsOptions,
    refreshProfileStudySessions,
    resetStore,
  ]);

  if (!studySessionsOptions || !profileStudySessions)
    return (
      <>
        <StudySessionsFeedback />
        <ProfileLoader key="profile-loader" />
      </>
    );

  return (
    <>
      <StudySessionsFeedback />
      <StudySessionForm
        dict={dict}
        eventBus={eventBus}
        studySessionsOptions={studySessionsOptions}
        profileStudySessions={profileStudySessions}
      />
    </>
  );
};

export default StudySessionScreen;
